import { useNavigate } from "react-router-dom";
import AnuncioService from "../../services/AnuncioService";
import { AnunciosData, GetVoidAnunciosData } from "../../types/Anuncio/AnuncioData";
import { PaginateObj } from "../../types/Paginate/PaginateObjt";
import { useEffect, useState } from "react";
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Pagination, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { themePalette } from "../../config/theme.config";
import { textDateFormat, textDateTimeFormat } from "../../utils/dateFormat";
import { MdModeEdit } from "react-icons/md";
import { BsClockHistory } from "react-icons/bs";
import { BsTrash2 } from "react-icons/bs";
import { SpanRed } from "../../common/Behelit/Span";
import SweetAlertUtil from "../../utils/SweetAlert";

interface Props {
    page: PaginateObj<AnunciosData>;
    noHistorial?: boolean;
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const MisComunicadosTable: React.FC<Props> = ({ page, noHistorial = false }) => {
    const navigate = useNavigate();
    const [iPage, setIpage] = useState<PaginateObj<AnunciosData>>(page);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedAnuncio, setSelectedAnuncio] = useState<AnunciosData>(GetVoidAnunciosData());

    const fetchAnuncios = async () => {
        setLoading(true)
        try {
            if (iPage.totalPages > 1) {
                const response = await AnuncioService.GetPageByNumber(iPage.firstPage, currentPage)
                const data = response;
                // console.log(data);
                if (response.succeeded) {
                    setIpage(data);
                }
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const handleChangePage = (event: unknown, newPage: number) => {
        setCurrentPage(newPage); // Cambia la página
    };
    const select = (anuncio: AnunciosData) => {
        setSelectedAnuncio(anuncio);
        handleOpen();
    }
    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    }
    const handleDelete = async () => {
        setDisabled(true);
        await AnuncioService.DeleteMiAnuncio(selectedAnuncio.idAnuncio)
        .then((resp) => {
            handleClose();
            if(resp.status === 204){
                SweetAlertUtil.alertaExito('Exito', 'Se elimino el anuncio...');
                setTimeout(() => {
                    removeElementById(selectedAnuncio.idAnuncio);
                },3000)                
            }else{
                SweetAlertUtil.alertaAdvertencia('Alerta', resp.message)
            }
        })
        .catch((error) => {
            console.error(error)
        })
        .finally(() => {
                setDisabled(false);          
        })
    }
    const removeElementById = (idToRemove: number) => {
        setIpage((prevState) => ({
          ...prevState, // Mantiene las demás propiedades
          data: prevState.data.filter((item) => item.idAnuncio !== idToRemove), // Filtra la lista
        }));
    };
    // Effects
    useEffect(() => {
        fetchAnuncios();
    }, [currentPage]);

    return (
        <Container maxWidth="lg" style={{ marginTop: 10, marginLeft: 20, padding: '20px', textAlign: 'center' }}>
            {iPage.data.length === 0
                ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center', // Alinea el texto
                            backgroundColor: themePalette.BGWHITE, // Fondo claro
                        }}
                    >
                        <Typography variant="h4" color="primary">
                            Sin resultados
                        </Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                            {iPage.totalPages > 1 ? (
                                <Pagination
                                    count={iPage.totalPages} // Total de páginas
                                    page={currentPage} // Página actual
                                    onChange={handleChangePage} // Cambiar página
                                    color="primary"
                                    sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}
                                />
                            ) : (
                                <br />
                            )}
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>#</StyledTableCell>
                                        <StyledTableCell>Titulo</StyledTableCell>
                                        <StyledTableCell>Tipo</StyledTableCell>
                                        <StyledTableCell>Publicación</StyledTableCell>
                                        <StyledTableCell>Acción</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {iPage.data.map((row, index) => (
                                        <StyledTableRow key={row.idAnuncio}>
                                            <StyledTableCell component="th" scope="row">
                                                {index + (currentPage - 1) * 8 + 1}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.visited ? ('') : (<SpanRed texto="N" />)} {row.txTitulo.length > 50 ? `${row.txTitulo.slice(0, 50)}...` : row.txTitulo}
                                            </StyledTableCell>
                                            <StyledTableCell>{row.bdTipo === 'E' ? 'Evento' : 'Anuncio'}</StyledTableCell>
                                            <StyledTableCell>{textDateFormat(row.dtPublicacion)}</StyledTableCell>
                                            <StyledTableCell>
                                                <Grid container spacing={1}>
                                                    <Grid item sm={12} md={6} lg={4}>
                                                        <Tooltip title='Editar' placement='top' arrow>
                                                            <IconButton color="primary" disabled={disabled} onClick={() => navigate(`/creator/editanuncio/${row.idAnuncio}`)}>
                                                                <MdModeEdit />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    {!noHistorial ? <Grid item sm={12} md={6} lg={4}>
                                                        <Tooltip title='Historial' placement='top' arrow>
                                                            <IconButton color="secondary" disabled={disabled} onClick={() => navigate(`/creator/ver-historial/${row.idAnuncio}`)}>
                                                                <BsClockHistory />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid> : <></>}
                                                    {row.bdEstado !== 'U' ?
                                                        <Grid item sm={12} md={6} lg={4}>
                                                            <Tooltip title='Eliminar' placement='top' arrow>
                                                                <IconButton color="error" disabled={disabled} onClick={() => select(row)}>
                                                                    <BsTrash2 />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid> : <></>}
                                                </Grid>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                            {iPage.totalPages > 1 && (
                                <Pagination
                                    count={iPage.totalPages} // Total de páginas
                                    page={currentPage} // Página actual
                                    onChange={handleChangePage} // Cambiar página
                                    color="primary"
                                    sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}
                                />
                            )}
                        </Box>
                    </Grid>
                )}
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm" // Cambia a 'xs', 'sm', 'lg', etc.
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    Eliminar
                </DialogTitle>
                <DialogContent>
                    {`¿Desea eliminar el anuncio con título ${selectedAnuncio.txTitulo}?`}
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color="error" onClick={() => handleDelete()} endIcon={<BsTrash2 />}>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}
